(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bv-product-reviews')) {
    customElements.define('bv-product-reviews', class extends HTMLElement {
      connectedCallback() {
        this.rows = [...this.querySelectorAll('[data-review]')];
        this.size = Number(this.dataset.pageSize) || 3;
        this.page = 0;
        this.count = Math.ceil(this.rows.length / this.size);
        if (this.count < 2 || window.Shopify?.designMode) return;
        const nav = this.querySelector('nav');
        const pages = this.querySelector('[data-pages]');
        pages.replaceChildren();
        for (let page = 0; page < this.count; page++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(page + 1);
          button.addEventListener('click', () => this.showPage(page));
          pages.append(button);
        }
        this.querySelector('[data-prev]').onclick = () => this.showPage(this.page - 1);
        this.querySelector('[data-next]').onclick = () => this.showPage(this.page + 1);
        nav.hidden = false;
        this.showPage(0, false);
      }
      showPage(page, scroll = true) {
        this.page = Math.max(0, Math.min(page, this.count - 1));
        this.rows.forEach((row, index) => { row.hidden = Math.floor(index / this.size) !== this.page; });
        this.querySelectorAll('[data-pages] button').forEach((button, index) => {
          if (index === this.page) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        this.querySelector('[data-prev]').disabled = this.page === 0;
        this.querySelector('[data-next]').disabled = this.page === this.count - 1;
        if (scroll) {
          const status = this.querySelector('[data-status]');
          status.textContent = status.dataset.label.replace('[current]', this.page + 1).replace('[total]', this.count);
          this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-reference-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bv-reference-product')) {
    customElements.define('bv-reference-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        this.addEventListener('click', event => {
          const zoom = event.target.closest('[data-zoom]');
          if (zoom) {
            const source = zoom.querySelector('img');
            const target = dialog.querySelector('img');
            target.removeAttribute('srcset');
            target.removeAttribute('sizes');
            target.src = zoom.dataset.zoomSrc || source.currentSrc || source.src;
            target.alt = source.alt;
            dialog.showModal();
          }
          if (event.target.closest('.bv-pdp__close') || event.target === dialog) dialog.close();
          const sizeLink = event.target.closest('.bv-pdp__style a');
          if (sizeLink) {
            const details = this.querySelector(sizeLink.getAttribute('href'));
            if (details) details.open = true;
          }
        });
        this.addEventListener('change', event => {
          const choice = event.target.closest('[data-variant-url]');
          if (!choice) return;
          if (!choice.dataset.lens) {
            window.location.assign(choice.dataset.variantUrl);
            return;
          }
          const photo = this.querySelector('.bv-pdp__single-photo, .bv-pdp__hero');
          const image = choice.closest('label').querySelector('template').content.firstElementChild.cloneNode(true);
          image.alt ||= this.querySelector('h1').textContent + ' — ' + choice.dataset.lens;
          photo.replaceChildren(image);
          photo.dataset.zoomSrc = choice.dataset.photo;
          photo.setAttribute('aria-label', photo.getAttribute('aria-label').split(':')[0] + ': ' + image.alt);
          if (photo.classList.contains('bv-pdp__hero')) {
            photo.classList.toggle('bv-pdp__hero--variant', choice.dataset.variantPhoto === 'true');
          }
          this.querySelector('[data-lens-style]').textContent = choice.dataset.lens + ' tint / black frame';
          if (this.dataset.pageType === 'product') {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', choice.value);
            history.replaceState(history.state, '', url);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
